import { render, staticRenderFns } from "./VideoSlide.vue?vue&type=template&id=e61d4678&scoped=true&lang=pug"
import script from "./VideoSlide.vue?vue&type=script&lang=ts"
export * from "./VideoSlide.vue?vue&type=script&lang=ts"
import style0 from "./VideoSlide.vue?vue&type=style&index=0&id=e61d4678&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e61d4678",
  null
  
)

export default component.exports